export default __webpack_public_path__ + "static/jackson-galaxy-v2-019df6016586761f855c8805bf707140.jpg";